<template>
    <div id="page-main-footer" class="bg-secondary pb-5">
        <footer class="pt-5">
            <div class="container">
                <div class="row align-items-center justify-content-xl-between">
                    <div class="col-xl-6 p-0">
                        <div class="copyright text-center text-xl-left text-muted">
                        © 2019 <a href="/" class="font-weight-bold ml-1" target="_blank">Cutiefyme</a>
                        </div>
                    </div>
                    <div class="col-xl-6 p-0">
                        <ul class="nav nav-footer justify-content-center justify-content-xl-end">
                            <li class="nav-item"><a href="/" class="nav-link">Terms & Conditions</a></li>
                            <li class="nav-item"><a href="/" class="nav-link">Privacy Policy</a></li>
                            <li class="nav-item"><a href="/" class="nav-link">Policy Statement</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
import { default as config } from "@src/config";

export default {
    name: "GuestFooter",

    data: () => ({

    })
}
</script>